import React from "react";
import { Link } from "react-router-dom";
import style from "./error404.module.css";

export default function Error() {
  return (
    <div className={style.container}>
      

     
      <div className={style.contain}></div>
     
      
    
     
       
    
      <div className={style.btn}>
        <Link to="/home">
          <button> Return to home </button>
        </Link>
      </div>
    </div>
  );
}
